import { AppError } from '@app/errors/AppError'

import type { AddressSuggestFilter } from './addressSuggestion'
import type { GeocodeValidator } from './addressTools'

/** What a city input asks the backend for: cities alone, a few at a time. */
export const CITY_FILTER: AddressSuggestFilter = { kind: 'locality' }

export const CITY_SUGGESTIONS_LIMIT = 5

/** Refuses a pick that is not a city, with the input's own message. */
export const cityValidator =
  (localizedMessage: string): GeocodeValidator =>
  place => {
    if (!place.attributes.locality) throw new LocalityMissingError('Address is not locality').withLocalizedMessage(localizedMessage)
  }

class LocalityMissingError extends AppError {}
